import script from "./BaseAdvancedSearchToolbarButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseAdvancedSearchToolbarButton.vue?vue&type=script&setup=true&lang=js"

import "./BaseAdvancedSearchToolbarButton.vue?vue&type=style&index=0&id=7f5bbf52&lang=scss"

const __exports__ = script;

export default __exports__